import {connect} from 'react-redux';
import InspectionOtherPage from './InspectionOtherPage';
import {getCities} from "../../../../common/actions/general/getCities";
import {getStreets} from "../../../../common/actions/general/getStreets";


export default connect(
  null,
  {getCities, getStreets}
)(InspectionOtherPage);
